export default "__VITE_ASSET__IbejhQta__"